import { withPrefix } from 'gatsby';
import DOMPurify from 'isomorphic-dompurify';

export function sanitizeAndUpdatePreviewPaths(html: string): string {
  const sanitizedHtml = DOMPurify.sanitize(html);
  if (!process.env.GATSBY_PATH_PREFIX) {
    return sanitizedHtml;
  }
  // if URL starts with /, add prefix to href
  return sanitizedHtml.replaceAll('href="/', `href="${withPrefix('/')}`);
}
